import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accept", "children", "Button", "multiple", "onChange", "onClick", "use"];
import { Fragment, useRef } from 'react';
import styled from 'foundations-theming/utils';
import { Button } from '../../components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledInput = styled.input.withConfig({
  displayName: "FileButton__StyledInput"
})(() => {
  return {
    display: 'none'
  };
});
export const FileButton = _ref => {
  let {
      accept = [],
      children,
      Button: CustomButton = Button,
      multiple = false,
      onChange,
      onClick,
      use = 'tertiary-light'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const inputRef = useRef(null);
  const handleClick = evt => {
    if (evt) evt.preventDefault();
    if (inputRef.current) inputRef.current.click();
    if (onClick) onClick(evt);
  };
  const handleChange = evt => {
    if (typeof onChange === 'function') {
      if (onChange) onChange(evt);
      evt.target.value = '';
    }
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [CustomButton && /*#__PURE__*/_jsx(CustomButton, Object.assign({
      "data-component-name": "FileButton",
      onClick: () => handleClick(),
      use: use
    }, rest, {
      children: children
    })), /*#__PURE__*/_jsx(StyledInput, {
      ref: inputRef,
      type: "file",
      accept: accept.join(','),
      multiple: multiple,
      onChange: handleChange
    })]
  });
};
FileButton.displayName = 'FileButton';